import React from "react";

const TermsOfUse = () => {
  return (
    <div style={{maxWidth: "1000px", margin: "0 auto", padding: "50px", fontFamily: "Arial, sans-serif", lineHeight: "1.6", textAlign: "left" }}>
      <h1>EdXcelerate Terms of Use</h1>
      <p><strong>Effective Date:</strong> January 1, 2025</p>
      <p><strong>Contact:</strong> Ryan Foulke – ryan@edxcelerate.com</p>

      <p>
        Welcome to EdXcelerate! These Terms of Use ("Terms") govern your access to and use of EdXcelerate's platform, 
        tools, services, and content (collectively, the "Service"). By accessing or using the Service, you agree to be 
        bound by these Terms and our Privacy Policy.
      </p>
      <p>If you do not agree to these Terms, you may not use the Service.</p>

      <h2>1. Overview of EdXcelerate</h2>
      <p>
        EdXcelerate is an educational planning platform designed to help students, families, and educators organize, 
        assess, and improve educational paths. We are committed to protecting user privacy, promoting equitable access, 
        and supporting responsible use in compliance with educational and privacy laws.
      </p>

      <h2>2. FERPA and Student Data</h2>
      <p>
        EdXcelerate complies fully with the <strong>Family Educational Rights and Privacy Act (FERPA)</strong>. If you are an educator 
        or institution using EdXcelerate, you must ensure your use of student data through our platform complies with 
        FERPA and any other applicable laws.
      </p>
      <p>We do not share FERPA-protected data unless required by law or with appropriate written consent.</p>

      <h2>3. User Accounts</h2>
      <p>To access certain features of EdXcelerate, you may need to create an account. You agree to:</p>
      <ul>
        <li>Provide accurate, current, and complete information;</li>
        <li>Maintain the confidentiality of your login credentials;</li>
        <li>Be responsible for all activity under your account;</li>
        <li>Notify us immediately if you suspect unauthorized access or use.</li>
      </ul>
      <p>We reserve the right to suspend or terminate accounts for any violation of these Terms or our Acceptable Use Policy.</p>

      <h2>4. Acceptable Use</h2>
      <p>You agree not to use EdXcelerate in any way that:</p>
      <ul>
        <li>Violates any applicable law, including FERPA, anti-discrimination laws, or intellectual property laws;</li>
        <li>Harasses or harms others;</li>
        <li>Misuses, copies, or distributes EdXcelerate's materials for commercial gain;</li>
        <li>Attempts to reverse-engineer, disrupt, or compromise the security or integrity of our systems;</li>
        <li>Involves unauthorized access to other accounts or data.</li>
      </ul>
      <p>You may view our full Acceptable Use Policy for more detail.</p>

      <h2>5. Intellectual Property</h2>
      <p>
        All content, features, and functionality on the EdXcelerate platform—including logos, designs, software, and 
        documentation—are the exclusive property of EdXcelerate or its licensors.
      </p>
      <p>
        You are granted a limited, non-exclusive, non-transferable license to use the Service for personal, academic, 
        or institutional educational planning. All other rights are reserved.
      </p>

      <h2>6. Third-Party Services</h2>
      <p>
        EdXcelerate may integrate with or link to third-party tools or services (e.g., Google Drive, LMS platforms). 
        These services are governed by their own terms and privacy policies. EdXcelerate is not responsible for 
        third-party content, data practices, or availability.
      </p>

      <h2>7. Termination</h2>
      <p>
        We may suspend or terminate your access to the Service at any time, with or without notice, for any reason—including 
        violation of these Terms or applicable law. You may also cancel your account at any time.
      </p>
      <p>Upon termination, your access will be revoked and your data may be retained in accordance with our Privacy Policy.</p>

      <h2>8. Disclaimers and Limitation of Liability</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of any kind. EdXcelerate does not guarantee 
        that the Service will be error-free, uninterrupted, or suitable for your specific needs.
      </p>
      <p>To the fullest extent permitted by law, EdXcelerate and its officers, employees, and agents disclaim all liability for:</p>
      <ul>
        <li>Losses resulting from reliance on educational tools or suggestions;</li>
        <li>Unauthorized access to your account or data;</li>
        <li>Any indirect, incidental, or consequential damages.</li>
      </ul>
      <p>Some jurisdictions may not allow these exclusions, so parts of this section may not apply to you.</p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless EdXcelerate, its affiliates, and its personnel from any claims, losses, 
        liabilities, damages, or expenses arising from your use of the Service, your violation of these Terms, or your 
        infringement of any third-party rights.
      </p>

      <h2>10. Changes to These Terms</h2>
      <p>
        We may update these Terms occasionally. If we make material changes, we'll notify you by email or through the Service. 
        Continued use after changes constitutes your acceptance of the new Terms.
      </p>

      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of Nevada, without regard to its conflict of laws principles. 
        You agree to submit to the exclusive jurisdiction of courts located in that state for any dispute related to these 
        Terms or the Service.
      </p>

      <h2>12. Contact Us</h2>
      <p>For questions, feedback, or legal concerns, contact:</p>
      <p>
        Ryan Foulke<br />
        Email: ryan@edxcelerate.com
      </p>
    </div>
  );
};

export default TermsOfUse;